var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _radialGradient, _radialGradient2, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _radialGradient3, _radialGradient4, _path, _rect, _g, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRootCa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 19.250618,
    x2: 16.198252,
    y1: 7.737298,
    y2: 4.113376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6f716d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ea09c"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 10.650842,
    x2: 27.192274,
    y1: 0.987405,
    y2: 15.543732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cad0c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#eaece9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5cbc0"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(1.230769 0 0 .32409 -5.538462 32.89774)",
    gradientUnits: "userSpaceOnUse",
    x1: 27.8125,
    x2: 27.824219,
    xlinkHref: "#o",
    y1: 22.739454,
    y2: 26.024691
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(1.230769 0 0 .32409 -5.538462 30.89774)",
    gradientUnits: "userSpaceOnUse",
    x1: 27.8125,
    x2: 27.824219,
    xlinkHref: "#o",
    y1: 22.739454,
    y2: 26.024691
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientTransform: "matrix(1.230769 0 0 .32409 -5.538462 28.89774)",
    gradientUnits: "userSpaceOnUse",
    x1: 27.8125,
    x2: 27.824219,
    xlinkHref: "#o",
    y1: 22.739454,
    y2: 26.024691
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientTransform: "matrix(1.230769 0 0 .32409 -5.538462 26.89774)",
    gradientUnits: "userSpaceOnUse",
    x1: 27.8125,
    x2: 27.824219,
    xlinkHref: "#o",
    y1: 22.739454,
    y2: 26.024691
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientTransform: "matrix(1.230769 0 0 .32409 -5.538462 24.89774)",
    gradientUnits: "userSpaceOnUse",
    x1: 27.8125,
    x2: 27.824219,
    xlinkHref: "#o",
    y1: 22.739454,
    y2: 26.024691
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientTransform: "matrix(1.230769 0 0 .32409 -5.538462 22.89774)",
    gradientUnits: "userSpaceOnUse",
    x1: 27.8125,
    x2: 27.824219,
    xlinkHref: "#o",
    y1: 22.739454,
    y2: 26.024691
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientTransform: "matrix(1.230769 0 0 .32409 -5.538462 20.89774)",
    gradientUnits: "userSpaceOnUse",
    x1: 27.8125,
    x2: 27.824219,
    xlinkHref: "#o",
    y1: 22.739454,
    y2: 26.024691
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientTransform: "matrix(1.230769 0 0 .32409 -5.538462 18.89774)",
    gradientUnits: "userSpaceOnUse",
    x1: 27.8125,
    x2: 27.824219,
    xlinkHref: "#o",
    y1: 22.739454,
    y2: 26.024691
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientTransform: "matrix(1.230769 0 0 .32409 -5.538462 16.89774)",
    gradientUnits: "userSpaceOnUse",
    x1: 27.8125,
    x2: 27.824219,
    xlinkHref: "#o",
    y1: 22.739454,
    y2: 26.024691
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientTransform: "matrix(1.230769 0 0 .32409 -5.538462 14.89774)",
    gradientUnits: "userSpaceOnUse",
    x1: 27.8125,
    x2: 27.824219,
    xlinkHref: "#o",
    y1: 22.739454,
    y2: 26.024691
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.494845
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#896d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a18000",
    stopOpacity: 0.268041
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 22.571428,
    cy: 30.857143,
    gradientTransform: "matrix(1 0 0 .651376 0 10.75754)",
    gradientUnits: "userSpaceOnUse",
    r: 15.571428
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 12.845672,
    cy: 13.342374,
    gradientTransform: "matrix(2.531089 0 .00000001 2.860549 -19.66786 -16.33929)",
    gradientUnits: "userSpaceOnUse",
    r: 17,
    xlinkHref: "#n"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientTransform: "matrix(.999112 0 0 1.095802 .036421 -4.139733)",
    gradientUnits: "userSpaceOnUse",
    x1: 10.907269,
    x2: 30.875446,
    xlinkHref: "#m",
    y1: 25.002281,
    y2: 36.127281
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientTransform: "matrix(1 0 0 1.089878 0 -5.10979)",
    gradientUnits: "userSpaceOnUse",
    x1: 6.72682,
    x2: 40.938126,
    y1: 32.161697,
    y2: 32.161697
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ead200",
    stopOpacity: 0.713415
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20999999,
    stopColor: "#ffec41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83999997,
    stopColor: "#e2cc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3af00"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientTransform: "matrix(1 0 0 1.089878 0 -3.986899)",
    gradientUnits: "userSpaceOnUse",
    x1: 31.630468,
    x2: 8.671364,
    y1: 41.791817,
    y2: 25.793524
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be9700"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 24.875,
    x2: 24.75,
    y1: 22,
    y2: 18
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffec41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3af00"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientTransform: "matrix(1 0 0 .951923 0 1.975963)",
    gradientUnits: "userSpaceOnUse",
    x1: 21.941509,
    x2: 21.941509,
    xlinkHref: "#n",
    y1: 21.550869,
    y2: 18.037588
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 30.996042,
    cy: 13.156409,
    gradientTransform: "matrix(-.00000053 14.96898 -8.276676 .00039688 143.8949 -454.2723)",
    gradientUnits: "userSpaceOnUse",
    r: 1.000184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 12.184196,
    cy: 8.546344,
    gradientTransform: "matrix(-.441342 3.786965 -3.285907 -.382939 47.91818 -38.4483)",
    gradientUnits: "userSpaceOnUse",
    r: 3.603773,
    xlinkHref: "#m"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38.142857 30.857143a15.571428 10.142858 0 1 1 -31.142857 0 15.571428 10.142858 0 1 1 31.142857 0z",
    fill: "url(#p)",
    opacity: 0.473684,
    transform: "matrix(1.440225 0 0 .419014 -8.581573 29.82043)"
  })), /*#__PURE__*/React.createElement("rect", {
    height: 27.009277,
    rx: 2.234975,
    ry: 2.257053,
    style: {
      fillRule: "evenodd",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "url(#s)",
      stroke: "url(#t)"
    },
    width: 34.993771,
    x: 6.5,
    y: 17.5
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 25.006882,
    rx: 1.288511,
    stroke: "url(#r)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.601093,
    width: 33.000904,
    x: 7.5,
    y: 18.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.066291 0 0 1 -1.59099 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 23h32v.972271h-32z",
    fill: "url(#l)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 25h32v.972271h-32z",
    fill: "url(#k)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 27h32v.972271h-32z",
    fill: "url(#j)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 29h32v.972271h-32z",
    fill: "url(#i)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 31h32v.972271h-32z",
    fill: "url(#h)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 33h32v.972271h-32z",
    fill: "url(#g)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 35h32v.972271h-32z",
    fill: "url(#f)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 37h32v.972271h-32z",
    fill: "url(#e)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 39h32v.972271h-32z",
    fill: "url(#d)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 41h32v.972271h-32z",
    fill: "url(#c)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#u)",
    height: 4,
    rx: 1.714645,
    ry: 1.661073,
    width: 34,
    x: 7,
    y: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.022894 21.954401h-30.0439712c-1.518102.008101-1.980695.640186-1.99632 2.380825v10.845656c5.3481802 4.75668 17.7926802-4.969999 34.0000002 0v-10.866696c-.012611-1.780269-.540848-2.346047-1.959709-2.359785z",
    fill: "url(#q)",
    opacity: 0.406593
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.987405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.5 20.234846v-7.234846c0-7.8701334 5.397609-11.6089934 13.520027-11.5107079 8.166613.0982856 13.479973 3.5479861 13.479973 11.5107079v7.234846c-.083947 1.703585-4.963388 1.697303-5 0v-5.234846c0-2 .638264-8.471853-8.422759-8.471853-9.123523 0-8.587252 6.511738-8.554561 8.463879v5.276498c-.21018 1.591322-5.02268 1.528822-5.02268-.033678z",
    fill: "url(#b)",
    stroke: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.496849 13.160018c.248424-4.3978382 1.416201-8.4519615 6.959268-9.9612363 1.580544 1.8244316-4.8983 1.9207621-4.997669 8.2829673 0 0 .02166 7.982511.02166 7.982511-.234835.588388-1.920759.606565-1.983259-.049685z",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.500368 9.7120694h2v9.6354126c-.0625 1.125-2.03125.53125-2 0z",
    fill: "url(#w)"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 2.85577,
    rx: 1.200194,
    ry: 1.096848,
    stroke: "url(#v)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    width: 33,
    x: 7.5,
    y: 18.634619
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRootCa);
export default __webpack_public_path__ + "static/media/root-ca.5e36ef0fa578ec1092f329be245a82b9.svg";
export { ForwardRef as ReactComponent };